<template>
  <layout-main-inner
    v-loading="loading"
    title="考试管理"
    class="flex-1">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">新增考试</el-button>
      <el-button
        type="primary"
        @click="downloadtemplate">下载报名模板</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <el-form
        slot="form"
        class="form-item-mt0"
        style="flex: 1"
        label-width="90px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="考试科目：">
              <subject-select
                v-model="config.subjectId"
                showAll />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="考试状态：">
              <exam-status-select
                v-model="config.status" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="考试名称：">
              <el-input
                v-model="config.examName"
                clearable
                placeholder="请输入考试名称"
                @clear="handleCurrentChange(1)">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="handleCurrentChange(1)"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="考试名称"
          min-width="320"
          prop="examName">
          <template slot-scope="{ row }">
            <el-link
              style="font-size:12px"
              :underline="false"
              type="primary"
              @click="toDetail(row)">{{ row.examName }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="考试科目"
          min-width="100"
          prop="subjectName"></el-table-column>
        <el-table-column
          label="通过/参加/报名人数"
          min-width="140"
          prop="examName">
          <template slot-scope="{ row }">{{ row.passingCount }}/{{ row.examineeCount }}/{{ row.registrationCount }}</template>
        </el-table-column>
        <el-table-column
          label="考试时间"
          min-width="220"
          prop="account">
          <template slot-scope="{ row }">{{ row.beginTime | dateformat('YYYY-MM-DD HH:mm') }}至{{ row.endTime | dateformat('YYYY-MM-DD HH:mm') }}</template>
        </el-table-column>
        <el-table-column
          label="状态"
          min-width="60"
          prop="status">
          <template slot-scope="{ row }">{{ row.status | examStatusName() }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.status > 4"
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :disabled="row.status !== 4"
                  @click.native="deleteitem(row)">删除</el-dropdown-item>
                <el-dropdown-item
                  :disabled="![5,6].includes(row.status)"
                  @click.native="uploadUser(row)">导入考生名单</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status === 4)"
                  @click.native="changeStatus(row,5,'发布考试')">发布考试</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status === 6)"
                  @click.native="changeStatus(row,7,'提前结束考试')">提前结束考试</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status === 7)"
                  @click.native="changeStatus(row,8,'发布成绩')">发布成绩</el-dropdown-item>
                <el-dropdown-item
                  :disabled="![5,6].includes(row.status)"
                  @click.native="changeStatus(row,15,'中止考试')">中止考试</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status === 7)"
                  @click.native="downloadexamscoretemplate(row)">下载成绩导入模板</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
    <examination-modal
      ref="modal"
      :callback="getlist" />
    <upload-new ref="uploadNew" />
  </layout-main-inner>
</template>
<script>
import ExaminationModal from './busi/examination-modal.vue'
import SubjectSelect from '../subject-select.vue'
import ExamStatusSelect from '../exam-status-select.vue'
import { downloadBlobFile } from '../../../utils/index'
import UploadNew from '../../../components/upload-new.vue'
export default {
  name: 'ExaminationIndex',
  components: { ExaminationModal, SubjectSelect, ExamStatusSelect, UploadNew },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, subjectId: null, status: null, examName: '' }
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    downloadexamscoretemplate(row) {
      this.loading = true
      this.$$examApi.downloadexamscoretemplate({ examId: row.id })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    downloadtemplate() {
      this.loading = true
      this.$$examApi.downloadexamregistrationtemplate({ })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    uploadUser(row) {
      this.$refs.uploadNew.upload({ examId: row.id }, (formData) => {
        this.$$examApi.uploadexamregistration(formData)
          .then(res => {
            this.loading = false
            const { result, message } = res.data
            if ([0].includes(result)) {
              this.$message.success('上传成功')
              this.getlist()
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      })
    },
    toDetail(row) {
      this.$router.push({ path: '/exam-examination-detail/' + row.id })
    },
    additem() {
      this.$refs.modal.init()
    },
    updateitem(row) {
      const {
        id, examName, subjectId, subjectName, status, passingScore, secondScoreName, secondScore, thirdScoreName, thirdScore,
        paperId, paperName, paperScore, examMinutes, beginTime, endTime
      } = row
      const rangeTime = [beginTime, endTime]
      this.$refs.modal.init({
        id, examName, subjectId, subjectName, status, passingScore, secondScoreName, secondScore, thirdScoreName, thirdScore,
        paperId, paperName, paperScore, examMinutes, rangeTime
      })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该考试?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$examApi.deleteexam({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    changeStatus(row, status, title) {
      this.$confirm(`您确定${title}?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$examApi.updateexam({ id: row.id, status })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success(title + '成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$examApi.getexams(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
